import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { LockIcon } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function OfferCTA() {
  return <section id="precio" className="py-12 sm:py-16 lg:py-24 relative bg-dark-surface border-t border-gold/20 overflow-hidden" data-id="element-111">
      {/* Ambient background glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-gold/5 blur-[100px] pointer-events-none" data-id="element-112" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-113">
        <div className="glass-card p-5 sm:p-8 md:p-12 lg:p-16 text-center relative" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mb-6 sm:mb-8" data-id="element-115">
            <span className="inline-block px-3 sm:px-4 py-1 bg-red-dark/30 border border-red-urgent text-red-urgent font-bold tracking-widest text-xs sm:text-sm rounded-full mb-4 sm:mb-6 animate-pulse" data-id="element-116">
              OFERTA DE LANZAMIENTO
            </span>

            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4" data-id="element-117">
              RECLAMA TU IDENTIDAD DE TITÁN
            </h2>
            <p className="text-sm sm:text-base text-gray-400 max-w-2xl mx-auto" data-id="element-118">
              El precio normal de este entrenamiento de identidad es de{' '}
              <span className="line-through text-gray-500" data-id="element-119">$20 USD</span>. Pero
              para nuestra legión de lanzamiento con un{' '}
              <span className="text-red-urgent font-bold" data-id="element-120">
                50% de descuento
              </span>
              ...
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="mb-8 sm:mb-10" data-id="element-121">
            <div className="text-base sm:text-lg lg:text-xl text-gold font-bold tracking-widest mb-2" data-id="element-122">
              SOLO POR HOY — 50% DE DESCUENTO
            </div>
            <div className="flex items-baseline justify-center gap-3 sm:gap-4 mb-1" data-id="element-123">
              <span className="text-2xl sm:text-3xl lg:text-4xl font-cinzel font-bold text-gray-500 line-through decoration-red-urgent/70 decoration-2" data-id="element-124">
                $20.00
              </span>
            </div>
            <div className="text-5xl sm:text-6xl lg:text-8xl font-black text-white font-cinzel text-glow-gold drop-shadow-2xl" data-id="element-125">
              $10
              <span className="text-2xl sm:text-3xl lg:text-4xl text-gold" data-id="element-126">
                .00
              </span>{' '}
              <span className="text-xl sm:text-2xl lg:text-3xl text-gray-400 font-inter font-normal" data-id="element-127">
                USD
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="max-w-md mx-auto" data-id="element-128">
            <Button fullWidth href="https://despertartitan.it.com/cart/46572248334476:1" onClick={() => trackEvent('AddToCart', {
            content_name: 'El Protocolo Estoico',
            content_type: 'product',
            value: 10,
            currency: 'USD'
          })} className="text-base sm:text-lg lg:text-xl py-4 sm:py-5 lg:py-6 mb-4 sm:mb-6" data-id="element-129">
              ¡QUIERO EL PROTOCOLO Y SER UN TITÁN!
            </Button>

            <div className="flex items-center justify-center gap-2 text-xs sm:text-sm text-gray-500" data-id="element-130">
              <LockIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" data-id="element-131" />
              <span data-id="element-132">
                Acceso instantáneo por solo $10 USD. Pago seguro y cifrado.
              </span>
            </div>
          </motion.div>

          {/* Small mockup image at bottom */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="mt-10 sm:mt-16 pt-8 sm:pt-12 border-t border-dark-border flex justify-center" data-id="element-133">
            <img src="https://cdn.magicpatterns.com/uploads/52ZnEXfTEtHTdeud3MBxJB/IMG_5195.png" alt="El Protocolo Estoico — Guerrero Espartano" className="w-full max-w-[180px] sm:max-w-xs opacity-50 hover:opacity-100 transition-opacity duration-500 rounded-lg" data-id="element-134" />
          </motion.div>
        </div>
      </div>
    </section>;
}